import React, { useEffect, useState } from 'react'
import { Grid, Row, Col, Button, Input, SelectPicker, Form, Panel } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
// //import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import ExpertListTable from '../../../components/table/expertListTable/ExpertListTable'
import { searchExpert } from '../../../redux/actions/assignExpert'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import ViewButton from '../../../components/buttons/viewButton/ViewButton'
import ExpertListTableNewer from '../../../components/table/expertListTable/ExpertListTableLastYear'

export default function SeachExpertNewer({
  schema,
  selectedExpert,
  onClickSelect,
  onClickOnline,
  isSubProject,
}) {
  const { register, handleSubmit, errors, control, reset } = useForm()

  //const [expertData, setExpertData] = useState(schema.itemsList || [])
  const [expertData, setExpertData] = useState([])
  const [totalSize, setTotalSize] = useState(schema.totalSize || schema?.itemsList?.length || 0)
  const [currentSeach, setCurrentSeach] = useState()

  useEffect(() => {
    handleSearchExpert({ name: '', expert: '', accountType: '', year: '' }, 1, 5)
  }, [])

  const GetBudgetYear = () => {
    var defaultYear = new Date().getFullYear() + 543
    if (new Date().getMonth() >= 9) {
      defaultYear = new Date().getFullYear() + 543 + 1 //ปีงบประมาณ = ปีปัจุบัน+1 (เดือน 10 11 12)
    }
    return defaultYear
  }

  const handleSearchExpert = async (data, pagenum, pagesize) => {
    let search = {
      name: data?.name,
      expert: data?.expert,
      accountType: data?.accountType,
      year: data?.year && !isNaN(data?.year) ? parseInt(data?.year, 10) : null,
      isNewExpert: true
    }

    const searchResult = await searchExpert(search, pagenum, pagesize)

    setTotalSize(searchResult?.model?.totalSize)
    setExpertData(searchResult?.model?.itemsList)
  }

  const handleChangePage = (pagesize, pagenum) => {
    handleSearchExpert(currentSeach, pagenum, pagesize)
  }

  const onSubmit = (data) => {
    setCurrentSeach(data)
    handleSearchExpert(data, 1, 5)
  }

  const onClickClearValue = () => {
    setExpertData()
    reset({ name: '', expert: '', accountType: '', year: '' })
  }

  return (
    <>
      <Panel
        shaded
        header={schema?.headerSummary || 'ผู้ทรงคุณวุฒิรายใหม่ในปีนี้'}
        bordered
        collapsible
        defaultExpanded
      >
        <ExpertListTableNewer
          data={expertData}
          selectedExpert={selectedExpert}
          isEditable
          isSubProject={isSubProject}
          onClickSelect={onClickSelect}
          onClickOnline={onClickOnline}
          onReload={handleChangePage}
          totalSize={totalSize}
        />
      </Panel>
    </>
  )
}
